import { Component, OnInit, input, output } from '@angular/core';

@Component({
    selector: 'app-clientknowledge',
    templateUrl: './clientknowledge.component.html',
    styleUrls: ['./clientknowledge.component.scss'],
    standalone: false
})
export class ClientknowledgeComponent implements OnInit {

  openClientKnowledge = output<void>();

  readonly isFetching = input(false);
  readonly error = input('');

  constructor() {
  }

  ngOnInit(): void {
    this.emitOpenClientKnowledge();
  }

  emitOpenClientKnowledge(): void {
    this.openClientKnowledge.emit();
  }
}
